// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3-y-v","header":"ClearentDisclaimer_header__31boJ","inner":"ClearentDisclaimer_inner__28zJ2"};